import DataRoom from "components/global/DataRoom";

const VCDataRoom = () => <DataRoom documentBucket="ventureCapitalFirmDocuments" />;

export default VCDataRoom;
